import React from 'react';
import Sidebar from 'src/components/organisms/sidebar';
import Navbar from 'src/components/organisms/navbar';
import { Route, Switch } from 'react-router-dom';
import { IState } from 'src/types/state';
import { connect } from 'react-redux';
import { compose } from 'redux';
import lists from 'src/routes/private';
import DashboardLayout, { RenderElementProps } from './dashboard-layout';
import PageLoading from '../../pages/page-loading';
import findRolePermission from '../../../utils/role';

interface PropTypes{
  roles?: string[];
}

const VirgoBizDashboardLayout:React.FunctionComponent<PropTypes> = (props: PropTypes) => {
  const {
    // eslint-disable-next-line no-unused-vars
    roles,
  } = props;

  const renderSidebar = ({ onCloseDrawer }: RenderElementProps) => (
    <Sidebar
        // @ts-ignore
      onNavItemPress={onCloseDrawer}
    />
  );

  const renderNavbar = () => (
    <Navbar />
  );

  return (
    <DashboardLayout
      renderSidebar={renderSidebar}
      renderNavbar={renderNavbar}
    >
      <Switch>
        {
          lists.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              component={
                findRolePermission(route.key) ? route.component : PageLoading
              }
              exact
            />
          ))
        }
      </Switch>
    </DashboardLayout>
  );
};

const mapStateToProps = (state: IState) => ({
  roles: state.auth.userData.role,
});

const withConnect = connect(mapStateToProps, null);

export default compose(withConnect)(React.memo(VirgoBizDashboardLayout));
